module.exports = __webpack_public_path__ + "img/ignis.a8411f9d.svg";